import { FormControl, FormHelperText, FormLabel, Grid, OutlinedInput, styled } from '@mui/material';
import { FC } from 'react';
import GetRealm from '../../utils/getRealm';

const TextField = styled(OutlinedInput)(({ theme }) => ({
	color: 'black',
	background: `linear-gradient(90deg, ${
		GetRealm() === 'ACORN' ? theme.palette.secondary.main : '#4e56a2'
	} 10%,#ffcc00 10%)`,
	borderRadius: '4px',
	fontFamily: 'CharlesWright',
	textTransform: 'uppercase',
	lineHeight: 0,
	minHeight: 0,
	fontSize: '3rem',
	'& input': {
		textAlign: 'center',
		padding: 'unset',
		paddingLeft: '12% !important',
		textTransform: 'uppercase',
	},
}));

interface IProps {
	onChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
	name?: string;
	id?: string;
	error?: boolean;
	helperText?: string | false;
	value?: unknown;
	onBlur?: React.FocusEventHandler<HTMLTextAreaElement | HTMLInputElement>;
	onKeyDown?: React.KeyboardEventHandler<HTMLInputElement | HTMLTextAreaElement> | undefined;
}

const LicencePlateTextField: FC<IProps> = ({ error, helperText, id, onBlur, onChange, onKeyDown, ...rest }) => {
	return (
		<FormControl
			error={error}
			fullWidth
			component='fieldset'
			sx={{
				flexDirection: 'column',
				justifyContent: 'space-around',
				'& .MuiOutlinedInput-root': {
					'&.Mui-focused fieldset': {
						border: '1.5px solid rgba(0, 0, 0, 0.87)',
					},
				},
			}}
		>
			<Grid container direction='row' alignItems='center' spacing={1}>
				<Grid
					size={{ xs: 12, md: 4 }}
					sx={(theme) => ({
						textAlign: 'right',
						[theme.breakpoints.down('md')]: { textAlign: 'unset' },
					})}
				>
					<FormLabel htmlFor={id}>Registration number</FormLabel>
				</Grid>
				<Grid size={{ xs: 12, md: 8 }}>
					<TextField
						id={id}
						fullWidth
						{...rest}
						autoComplete='off'
						onChange={(event) => {
							onChange(event);
						}}
						onBlur={onBlur}
						onKeyDown={onKeyDown}
					/>
				</Grid>
			</Grid>
			<FormHelperText
				sx={(theme) => ({
					marginLeft: '35%',
					marginRight: 'auto',
					[theme.breakpoints.down('md')]: {
						marginLeft: 'unset',
						marginRight: 'unset',
					},
				})}
				id={`${id || ''}-helper-text`}
			>
				{helperText}
			</FormHelperText>
		</FormControl>
	);
};

export default LicencePlateTextField;
